import React from "react"

const EditIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.85">
        <path
          d="M10.4853 6.6776L9.54267 5.73494L3.33333 11.9443V12.8869H4.276L10.4853 6.6776ZM11.428 5.73494L12.3707 4.79227L11.428 3.8496L10.4853 4.79227L11.428 5.73494ZM4.828 14.2203H2V11.3916L10.9567 2.43494C11.0817 2.30996 11.2512 2.23975 11.428 2.23975C11.6048 2.23975 11.7743 2.30996 11.8993 2.43494L13.7853 4.32094C13.9103 4.44596 13.9805 4.61549 13.9805 4.79227C13.9805 4.96905 13.9103 5.13858 13.7853 5.2636L4.82867 14.2203H4.828Z"
          fill="#04B085"
        />
      </g>
    </svg>
  )
}

export default EditIcon
